<template>
  <v-dialog
      :value="value"
      @input="(v) => v || close()"
      max-width="750px">
    <v-card>
      <v-card-title>
        画像プレビュー
      </v-card-title>
      <v-card-text class="px-4 py-0" style="max-height: 65vh;">
        <v-row>
          <v-col cols>
            <div style="height: 100%; width: 368px;">
              <tui-image-editor
                  :include-ui="useDefaultUI"
                  :options="options"
                  ref="crop_tuiImageEditor"
                  @objectAdded="objectAdded"
                  @objectMoved="objectMoved"
                  @objectScaled="objectScaled"
                  @objectActivated="objectActivated"
                  @mouseup.native="mouseUp"
              ></tui-image-editor>
            </div>
<!--            <v-img :src="src" ref="image"></v-img>-->
          </v-col>
          <v-col cols>
            <v-row style="width: 350px">
              <v-col cols="7">
                <v-select
                    :disabled="!editable"
                    @change="changeErrorType"
                    v-model="errorType"
                    :items="errorTypes"
                    label="異常タイプ"
                    outlined
                    dense
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details
                    class="m-1"
                ></v-select>
              </v-col>
              <v-col cols="5">
                <v-select
                    :disabled="errorType === 'shadow' || !editable"
                    @change="changeErrorReason"
                    v-model="errorReason"
                    :items="errorReasons"
                    label="原因"
                    outlined
                    dense
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details
                    class="m-1"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                    :disabled="!editable"
                    v-on:focus="textareaFocus"
                    v-on:focusout="textareaFocusOut"
                    name="input-7-1"
                    filled
                    label="コメント"
                    auto-grow
                    v-model="errorNote"
                    clearable
                    ref="textarea"
                    outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click="cancel">キャンセル</v-btn>
        <v-btn depressed color="blue lighten-3" @click="download">ダウンロード</v-btn>
        <v-btn depressed color="primary" @click="upload" v-if="editable">保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";
import ImageEditor from '@toast-ui/vue-image-editor/src/ImageEditor.vue';
import {fabric} from "fabric";

export default {
  name: "CropImagePreview",
  props: ['value', 'image', 'cropRect', 'cropImage', 'filename', 'abnormality', 'strokeWidth', 'editable'],
  components: {
    'tui-image-editor': ImageEditor,
  },
  data() {
    return {
      folderId: this.$route.params.folderId,
      src: null,
      blob: null,
      errorTypes: [
        {text: "ホットスポット", value: "cell"},
        {text: "マルチホットスポット", value: "multicell"},
        {text: "クラスタバイパス", value: "cluster" },
        {text: "モジュール異常", value: "module"},
        {text: "ストリング異常", value: "string"},
        {text: "影", value: "shadow"},
        {text: 'ジャンクションボックス過熱', value: 'junction'},
        {text: 'ＰＩＤ現象の疑い', value: 'pid'}
      ],
      errorType: null,
      errorReasons: [
        {text: "割れ", value: "crack"},
        {text: "堆積物", value: "sediment"},
        {text: "植生", value: "vegetation"},
      ],
      errorReason: null,
      errorNote: null,
      useDefaultUI: true,
      options: { // for tui-image-editor component's "options" prop
        includeUI: 0,
        cssMaxWidth: 1000,
        cssMaxHeight: 1000,
        usageStatistics: false,
      },
      addedAbnormalities: [],
      deletedAbnormalities: [],
      modifiedAbnormalities: [],
      selectedShape: null,
      movedObject: null,
      scaledObject: null,
      deletedObject: null,
      errorNotes: {
        type: {
          'cell': 'モジュールの一部に発熱が見受けられます。',
          'multicell': '複数のセルに発熱が見受けられます。',
          'cluster': 'クラスタ全体が発熱している状態となっております。発熱箇所が発電に寄与していないもしくは、性能が極端に低下していると推定されます。',
          'string': 'ストリング全体が発熱している状態となっております。発熱箇所が発電に寄与していないもしくは、性能が極端に低下していると推定されます。',
          'shadow': '周囲の構造物・樹木によりモジュールに影がかかっております。\nこれにより、発電量が低下していると推定されます。',
          'junction': 'ジャンクションボックスが過熱している状態となっております。',
          'module': 'モジュール全体が発熱している状態となっております。\n本パネルは発電に寄与していないと推定されますので、取り換えを推奨いたします。',
          'pid': 'PID現象が発生していると推定されます。',
          null: ''
        },
        reason: {
          null: '',
          'unknown': '',
          'vegetation': 'こちらはモジュールセルを覆う草木の影により発生していると推定されます。',
          'sediment': 'こちらは堆積物により発生していると推定されます。',
          'crack': 'モジュールガラス面が割れており、絶縁性能低下に伴うPCS停止により発電量低下等を引き起こす可能性がありますので、取り換えを推奨いたします。'
        }
      },
      tmp_abnormality: [],
    }
  },
  methods: {
    close(){
      document.removeEventListener('keydown', this.keyDown);
      this.$emit('input');
    },
    upload(){
      const canvasSize = this.$refs.crop_tuiImageEditor.invoke('getCanvasSize');
      const image = this.$refs.crop_tuiImageEditor.invoke('toDataURL', {
        format: 'png',
        quality: 1,
        left: 0,
        top: 0,
        width: canvasSize.width,
        height: canvasSize.height
      });
      const block = image.split(";");
      // Get the content type of the image
      const contentType = block[0].split(":")[1];
      // get the real base64 content of the file
      const realData = block[1].split(",")[1];
      this.b64toBlob(realData, contentType);
      const data = new FormData();
      data.append("file", this.blob);
      data.append("info", JSON.stringify({filename: this.filename, cropRect: this.cropRect, errorType: this.errorType, errorReason: this.errorReason,  errorNote: this.errorNote, cropImage: this.cropImage}));

      this.axios
          .post(`/api/report/save-image/${this.folderId}`, data)
          .then((response) => {
            this.$emit('saved', true, {custom_id: response.data, errorType: this.errorType, errorReason: this.errorReason, errorNote: this.errorNote}, this.addedAbnormalities, this.modifiedAbnormalities, this.deletedAbnormalities);
            this.close();
            store.showSuccessDialog('保存されました。');
          })
          .catch(() => {
            this.$emit('saved', false);
            this.close();
            store.showErrorDialog('エラーが発生しましたので、再度て試してください。');
          });
    },
    cancel(){
      this.$emit('saved', false);
      this.close();
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      this.blob = new Blob(byteArrays, {type: contentType});
    },
    objectAdded(props){
      this.$refs.crop_tuiImageEditor.invoke('setObjectProperties', props.id, {
        controls: {
          ...fabric.Rect.prototype.controls,
          mtr: new fabric.Control({visible: false})
        }
      }).then(() => {
        this.addedAbnormalities.push(props);
        this.$refs.crop_tuiImageEditor.invoke('discardSelection');
      });
    },
    objectMoved(props){
      this.movedObject = props;
    },
    objectScaled(props){
      const oCoords = this.$refs.crop_tuiImageEditor.invoke('getObjectProperties', props.id, ['oCoords']);
      props.left = oCoords.oCoords.tl.x;
      props.top = oCoords.oCoords.tl.y;
      this.scaledObject = props;
    },
    objectActivated(props) {
      if (props.width === 20 && props.height === 20){
        setTimeout(() => {
          this.$refs.crop_tuiImageEditor.invoke('removeObject', props.id);
        }, 1);
      }
      else {
        this.selectedShape = props;
      }
    },
    keyDown(evt){
      if (evt.key === "Backspace" || evt.key === "Delete"){
        if (this.editable){
          this.deletedObject = this.selectedShape;
          this.selectedShape = null;
          if (this.deletedObject){
            const t = this.addedAbnormalities.findIndex(item => item.id === this.deletedObject.id);
            if (t >= 0){
              this.addedAbnormalities.splice(t, 1);
            }
            else {
              let i = this.modifiedAbnormalities.findIndex(item => item.id === this.deletedObject.id);
              if (i >= 0){
                this.modifiedAbnormalities.splice(i, 1);
              }
              i = this.tmp_abnormality.findIndex(item => item.id === this.deletedObject.id);
              if (i >= 0){
                this.deletedObject.custom_id = this.tmp_abnormality[i].custom_id;
                this.tmp_abnormality.splice(i, 1);
                this.deletedAbnormalities.push(this.deletedObject);
              }
            }
            this.deletedObject = null;
          }
        }
      }
    },
    textareaFocus(){
      this.$refs.crop_tuiImageEditor.invoke('discardSelection');
      document.removeEventListener('keydown', this.keyDown);
    },
    textareaFocusOut(){
      document.addEventListener('keydown', this.keyDown);
    },
    download(){
      const canvasSize = this.$refs.crop_tuiImageEditor.invoke('getCanvasSize');
      const url = this.$refs.crop_tuiImageEditor.invoke('toDataURL', {
        left: 0,
        top: 0,
        width: canvasSize.width,
        height: canvasSize.height
      });
      const link = document.createElement('a');
      link.setAttribute('download', `${this.filename.split('.')[0]}_${Date.now()}_crop.png`);
      link.setAttribute('href', url.replace("image/png", "image/octet-stream"));
      link.click();
    },
    mouseUp(){
      if (this.movedObject){
        this.movedObject['modified'] = 'moved';
        const t = this.addedAbnormalities.findIndex(item => item.id === this.movedObject.id);
        if (t >= 0){
          this.addedAbnormalities[t].top = this.movedObject.top;
          this.addedAbnormalities[t].left = this.movedObject.left;
          this.addedAbnormalities[t]['modified'] = 'moved';
        }
        else {
          const i = this.tmp_abnormality.findIndex(item => item.id === this.movedObject.id);
          if (i >= 0) {
            this.movedObject.custom_id = this.tmp_abnormality[i].custom_id;
          }
          const a = this.modifiedAbnormalities.findIndex(item => item.id === this.movedObject.id);
          if (a >= 0) {
            this.modifiedAbnormalities[a].top = this.movedObject.top;
            this.modifiedAbnormalities[a].left = this.movedObject.left;
            this.modifiedAbnormalities[a]['modified'] = 'moved';
          } else {
            this.modifiedAbnormalities.push(this.movedObject);
          }
        }
        this.movedObject = null;
      }
      if (this.scaledObject){
        this.scaledObject['modified'] = 'scaled';
        const t = this.addedAbnormalities.findIndex(item => item.id === this.scaledObject.id);
        if (t >= 0){
          this.addedAbnormalities[t].top = this.scaledObject.top;
          this.addedAbnormalities[t].left = this.scaledObject.left;
          this.addedAbnormalities[t].width = this.scaledObject.width;
          this.addedAbnormalities[t].height = this.scaledObject.height;
          this.addedAbnormalities[t]['modified'] = 'scaled';
        }
        else {
          const i = this.tmp_abnormality.findIndex(item => item.id === this.scaledObject.id);
          if (i >= 0) {
            this.scaledObject.custom_id = this.tmp_abnormality[i].custom_id;
          }
          const a = this.modifiedAbnormalities.findIndex(item => item.id === this.scaledObject.id);
          if (a >= 0) {
            this.modifiedAbnormalities[a].top = this.scaledObject.top;
            this.modifiedAbnormalities[a].left = this.scaledObject.left;
            this.modifiedAbnormalities[a].width = this.scaledObject.width;
            this.modifiedAbnormalities[a].height = this.scaledObject.height;
            this.modifiedAbnormalities[a]['modified'] = 'scaled';
          }
          else {
            this.modifiedAbnormalities.push(this.scaledObject);
          }
        }
        this.scaledObject = null;
      }
    },
    changeErrorType(){
      if (!this.errorType){
        this.errorType = null;
        this.errorNote = this.errorNotes.reason[this.errorReason];
      }
      else{
        if (this.errorType === 'shadow'){
          this.errorReason = null;
        }
        this.errorNote = this.errorNotes.type[this.errorType] + '\n' + this.errorNotes.reason[this.errorReason];
      }
    },
    changeErrorReason(){
      if (!this.errorReason){
        this.errorReason = null;
      }
      if (!this.errorType){
        this.errorType = null;
        this.errorNote = this.errorNotes.reason[this.errorReason];
      }
      else{
        this.errorNote = this.errorNotes.type[this.errorType] + '\n' + this.errorNotes.reason[this.errorReason];
      }
    }
  },
  mounted() {
    this.src = this.image;
    if (this.cropImage){
      this.errorType = this.cropImage.errorType;
      this.errorNote = this.cropImage.errorNote;
      this.errorReason = this.cropImage.errorReason;
    }
    this.$refs.crop_tuiImageEditor.invoke('loadImageFromURL', this.src, 'tmp_crop.png').then(() => {
      this.$emit('turnoff');
      this.abnormality.forEach((item) => {
        setTimeout(() => {
          this.$refs.crop_tuiImageEditor.invoke('addShape', 'rect', {
            fill: 'transparent',
            stroke: item.stroke,
            strokeWidth: this.strokeWidth,
            left: item.left - this.cropRect.left + this.cropRect.width/2,
            top: item.top - this.cropRect.top + this.cropRect.height/2,
            width: item.width,
            height: item.height,
            isRegular: false,
            controls: {
              ...fabric.Rect.prototype.controls,
              mtr: new fabric.Control({visible: false})
            },
            selectable: this.editable
          }).then((shape) => {
            this.$refs.crop_tuiImageEditor.invoke('discardSelection');
            shape['custom_id'] = item.custom_id;
            this.tmp_abnormality.push(shape);
          });
        }, 10);
      });
      if (this.editable){
        this.$refs.crop_tuiImageEditor.invoke('startDrawingMode', 'SHAPE');
        this.$refs.crop_tuiImageEditor.invoke('setDrawingShape', 'rect', {
          fill: 'transparent',
          stroke: '#FF5252',
          strokeWidth: this.strokeWidth
        });
      }
    });
    document.addEventListener('keydown', this.keyDown);
  },
}
</script>

<style scoped>

</style>
